/* eslint-disable no-nested-ternary */
import { List } from '@hiiretail/react-foundation-ui';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import CircularProgress from '@mui/material/CircularProgress';
import { Item } from 'app/services/itemsSearchService/itemsSearchTypes';
import { FC, Fragment, ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { ItemsSearchPlaceholder } from './ItemsSearchPlaceholder';

interface ItemsSearchListProps {
  data: Item[];
  loading: boolean;
  renderItem: (item: Item) => ReactNode;
}

const styles = {
  list: {
    width: 'inherit',
    position: 'absolute',
    overflow: 'auto',
    maxHeight: '250px',
    borderRadius: '4px',
    background: '#FFF',
    boxShadow: 'rgba(0, 0, 0, 0.15) 0px 2px 4px',
    zIndex: 150,
    top: '65px',
  },
};

export const ItemsSearchList: FC<ItemsSearchListProps> = ({ data = [], loading, renderItem }) => {
  const intl = useIntl();

  return (
    <List role="listbox" sx={styles.list}>
      {loading ? (
        <ItemsSearchPlaceholder
          icon={<CircularProgress size={20} />}
          text={intl.formatMessage({ id: 'items.search.autcomplete.searching' })}
        />
      ) : data.length === 0 ? (
        <ItemsSearchPlaceholder
          icon={<SearchOffIcon />}
          text={intl.formatMessage({ id: 'items.search.autcomplete.results.not.found' })}
        />
      ) : (
        data.map((item, index) => <Fragment key={index}>{renderItem(item)}</Fragment>)
      )}
    </List>
  );
};
